import { DropdownContainer } from '@lib/components'
import { Check, IconArrowDownLine, IconArrowUpLine } from '@lib/icons'
import type { ColorLegendPosition } from '@octopus-do/octopus-project-core'
import { useProjectLegacyActions } from '@store/migrationActions/useProjectLegacyActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './ColorLegend.module.scss'

type Props = {
  disabled?: boolean
}

export const ColorLegend: React.FC<Props> = ({ disabled = false }) => {
  const legendPosition = useSelector(
    migrationProjectSelector.getProjectLegendPosition
  )

  const { changeProjectLegendPosition } = useProjectLegacyActions()

  const top = legendPosition === 'top'
  const bottom = legendPosition === 'bottom'
  const none = legendPosition === 'none'

  const onClick = (legendPosition: ColorLegendPosition) => {
    changeProjectLegendPosition({ legendPosition })
  }

  return (
    <div className={css.container}>
      Color legend
      <DropdownContainer
        position="bottom-end"
        renderButton={(onSetRef, onClick, isOpen) => (
          <div
            ref={onSetRef}
            className={cx(css.button, {
              [css.active]: isOpen,
              [css.disabled]: disabled,
            })}
            onClick={() => !disabled && onClick()}
          >
            {bottom && 'Bottom'}
            {top && 'Top'}
            {none && 'Hidden'}

            <div className={cx(css.icon, { [css.hidden]: none })}>
              {bottom ? <IconArrowDownLine /> : null}
              {top ? <IconArrowUpLine /> : null}
            </div>
          </div>
        )}
      >
        {(closeDropdown) => (
          <>
            <button
              onClick={() => {
                onClick('top')
                closeDropdown()
              }}
              className={css.dropdownItem}
            >
              <IconArrowUpLine />
              Top
              {top && <Check size={16} left={0} className={css.checkIcon} />}
            </button>

            <button
              onClick={() => {
                onClick('bottom')
                closeDropdown()
              }}
              className={css.dropdownItem}
            >
              <IconArrowDownLine />
              Bottom
              {bottom && <Check size={16} left={0} className={css.checkIcon} />}
            </button>

            <div className={css.divider} />

            <button
              onClick={() => {
                onClick('none')

                sendGtmEvent(
                  GtmTriggerName.COLOR_LEGEND_HIDE,
                  'Hide project legend'
                )

                closeDropdown()
              }}
              className={css.dropdownItem}
            >
              Hidden
              {none && <Check size={16} left={0} className={css.checkIcon} />}
            </button>
          </>
        )}
      </DropdownContainer>
    </div>
  )
}
